@use '../cuesheetRows' as rows;
@include rows.cuesheet-row-columns;

.eventRow {
  background: color-mix(in srgb, transparent 92%, var(--user-bg, $gray-500) 8%);
  border-left: 4px solid var(--user-bg, $gray-500);
  min-height: 2.5rem;

  &:hover {
    outline: 1px solid $blue-500;
    outline-offset: -1px;
    background: color-mix(in srgb, transparent 80%, var(--user-bg, $gray-500) 20%);
  }

  &[data-cursor='true'] {
    outline: 2px solid $blue-500;
    outline-offset: -2px;
    background: color-mix(in srgb, transparent 80%, var(--user-bg, $gray-500) 20%);
  }

  &.firstAfterGroup {
    margin-top: 2rem;
  }

  &.skip {
    position: relative;

    .indexColumn {
      text-decoration: line-through;
      opacity: $opacity-disabled;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      background: repeating-linear-gradient(
        -45deg,
        rgba(255, 255, 255, 0.03),
        rgba(255, 255, 255, 0.03) 10px,
        rgba(255, 255, 255, 0.08) 10px,
        rgba(255, 255, 255, 0.08) 20px
      );
    }
  }

  td {
    background-color: $gray-1200;
    border-radius: 2px;
  }
}
